import { PageValidationErrorNamesEnum } from './page-validation-error-names.enum';

export default class PageValidateModel {
  public validationResult: PageValidationErrorNamesEnum;
  public cartDetails: any;
  public showLead: boolean;
  public redirectUrl: string;
  public analyticalData: any;
  public _source: '' | 'firstPage' | 'authService';

  constructor(
    _pageValidateResponse: PageValidateModel
  ) {
    this.validationResult = _pageValidateResponse.validationResult || null;
    this.cartDetails = _pageValidateResponse.cartDetails || null;
    this.showLead = _pageValidateResponse.showLead || false;
    this.redirectUrl = _pageValidateResponse.redirectUrl || null;
    this.analyticalData = _pageValidateResponse.analyticalData || null;
    this._source = _pageValidateResponse._source || '';
  }
}
